import { useQuery } from '@apollo/client'
import React, { useEffect, useState } from 'react'
import { GET_ACTIVITY_PROCESSES_COUNTERS } from '../../../graphql/Catalog/Processes/Dashboards/dashboardProcesses'
import { toastSweetAlert } from '../../Helpers/ToastSweetAlert'
import Box from '../../Global/Box'
import CategoryFilter from '../../Admin/Documents/ReportsCounters/components/CategoryFilter'
import { GET_ALL_PROCESSES_WITH_SUBCATEGORIES_BY_CONTEXT } from '../../../graphql/Catalog/Processes/ProcessesCategories'
import KpiGraphics from '../../Admin/Documents/ReportsCounters/components/KpiGraphics'
import { GET_LAST_ONES_TIMELINES } from '../../../graphql/Catalog/Timeline/timelines'
import ActivityTimeline from '../../Admin/Documents/ReportsCounters/components/ActivitiTimeLine'

const DashboardGestorTramite = () => {
  const [counter, setCounter] = useState(null)
  const [optionsCategories, setOptionsCategories] = useState([])
  const [timeline, setTimeline] = useState({
    latest: [],
  })
  const [filters, setFilters] = useState({
    array_process_category_id: null,
    array_process_category_sub_id: null,
  })

  const {
    data: dataProcessCounters,
    loading: loadingProcessCounters,
    error: errorProcessCounters,
  } = useQuery(GET_ACTIVITY_PROCESSES_COUNTERS, {
    variables: { filters: filters },
    fetchPolicy: 'no-cache',
  })

  const {
    data: dataOptionsCategories,
    loading: loadingOptionsCategories,
    error: errorOptionsCategories,
  } = useQuery(GET_ALL_PROCESSES_WITH_SUBCATEGORIES_BY_CONTEXT, {
    fetchPolicy: 'no-cache',
  })

  const {
    data: dataTimeline,
    loading: loadingTimeline,
    error: errorTimeline,
  } = useQuery(GET_LAST_ONES_TIMELINES, {
    variables: { category: ['process'], limit: 10 },
    fetchPolicy: 'no-cache',
  })

  useEffect(() => {
    try {
      if (loadingProcessCounters) return
      if (errorProcessCounters) throw new Error(errorProcessCounters.message)
      setCounter(dataProcessCounters.getActivityProcessCountersByRol.process)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataProcessCounters, loadingProcessCounters, errorProcessCounters])

  useEffect(() => {
    try {
      if (loadingOptionsCategories) return
      if (errorOptionsCategories)
        throw new Error(errorOptionsCategories.message)

      const listCategories =
        dataOptionsCategories.getAllProcessesCategoriesAndSubCategoriesByContext.map(
          (item) => {
            return {
              label: item.name,
              options: item.ProcessesCategoriesToSubCategories.map(
                (subItem) => {
                  return {
                    category_group_name: item.name,
                    label: subItem.name,
                    value: subItem.id,
                  }
                }
              ),
            }
          }
        )

      setOptionsCategories(listCategories)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingOptionsCategories, errorOptionsCategories, dataOptionsCategories])

  useEffect(() => {
    try {
      if (loadingTimeline) return
      if (errorTimeline) throw new Error(errorTimeline.message)

      setTimeline({
        latest: dataTimeline.getLastOnesTimelines,
      })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingTimeline, errorTimeline, dataTimeline])

  const handleChangeCategoriesSubs = (selected) => {
    if (selected?.length === 0) {
      return setFilters({ array_process_category_sub_id: null })
    }
    setFilters({
      array_process_category_sub_id: selected.map((item) => item.value),
    })
  }

  return (
    <>
      <Box
        title="Indicadores"
        classNameHeader="mt-3"
        contentHeader=""
        content={
          <>
            <CategoryFilter
              titleContent={
                <label>
                  Tipo de trámite{' '}
                  <small>
                    (Puedes filtrar, selecciona una o varias opciones)
                  </small>
                </label>
              }
              options={optionsCategories}
              customFilter
              onChange={handleChangeCategoriesSubs}
            />
            {counter && (
              <KpiGraphics
                data={counter}
                titleLabelsStatus={['Completados', 'Pendientes', 'Negados']}
                titlelabelStatus="Número de trámites por estatus"
                barPlatform={false}
              />
            )}
          </>
        }
      />
      <ActivityTimeline
        timeline={timeline.latest}
        loading={loadingTimeline}
        hideButton
      />
    </>
  )
}

export default DashboardGestorTramite
